
import React, { useContext } from "react";
import { FaBalanceScale, FaGavel, FaFileContract, FaClipboardCheck } from 'react-icons/fa';
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import './ComplianceGlobal.css';
import BannerImage from './compliance_hero.png';

function SafetyLegalCompliance() {
  const navigate = useNavigate();
  const { isAuthenticated } = useContext(AuthContext);

  const handleBooking = () => {
    if (isAuthenticated) {
      navigate('/booking/safety-legal-compliance');
    } else {
      navigate('/login', { state: { from: '/booking/safety-legal-compliance' } });
    }
  };

  return (
    <div className="compliance-page">
      <div className="compliance-max-width">

        {/* --- HERO --- */}
        <div className="compliance-hero" style={{ backgroundImage: `url(${BannerImage})` }}>
          <span className="hero-tag">Regulatory Framework</span>
          <h1 className="hero-title">Safety Legal Compliance</h1>
          <p className="hero-subtitle">
            Navigating the complex landscape of health and safety laws.
            Ensuring your organization meets every statutory requirement.
          </p>
          <button onClick={handleBooking} className="btn-hero">
            Get Complied <span style={{ fontSize: '1.2em' }}>→</span>
          </button>
        </div>

        {/* --- CONTENT --- */}
        <div className="detail-content">

          <div className="content-article">
            <div className="article-section">
              <h2 className="article-heading">Why Compliance Matters</h2>
              <p className="article-text">
                Safety Legal Compliance is the bedrock of a responsible organization. It is not just about avoiding fines;
                it is about protecting your most valuable asset—your people. It typically involves adhering to the Factories Act,
                State Rules, Petroleum Act, and Explosives Act among others.
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Risk Management</h2>
              <p className="article-text">
                Compliance requires active monitoring. This includes hazard identification (HIRA), regular safety audits,
                and maintaining statutory registers. Ignorance of the law is not a defense in the event of an industrial accident.
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Documentation culture</h2>
              <p className="article-text">
                "If it isn't written down, it didn't happen." Accurate records of training, mock drills, accident reports,
                and equipment inspections are mandatory for legal audits. Transparancy builds trust with authorities and employees alike.
              </p>
            </div>
          </div>

          {/* --- SIDEBAR --- */}
          <div className="content-sidebar">
            <div className="sidebar-widget">
              <h4 className="widget-title">Key Obligations</h4>
              <ul className="key-list">
                <li><FaGavel className="check-icon" /> Statutory Compliance</li>
                <li><FaFileContract className="check-icon" /> License Renewals</li>
                <li><FaClipboardCheck className="check-icon" /> Third-party Audits</li>
                <li><FaBalanceScale className="check-icon" /> Liability Management</li>
              </ul>
            </div>

            <div className="sidebar-widget">
              <h4 className="widget-title">Did You Know?</h4>
              <p style={{ color: '#aaa', lineHeight: '1.6', fontSize: '0.9rem' }}>
                Non-compliance can lead to criminal prosecution of the Occupier and Factory Manager.
                Stay updated with the latest amendments.
              </p>
            </div>

            <div className="sidebar-widget" style={{ background: 'linear-gradient(135deg, #111 0%, #222 100%)', border: '1px solid #333' }}>
              <h4 className="widget-title">Legal Support</h4>
              <p style={{ color: '#ccc', marginBottom: '20px', fontSize: '0.9rem' }}>
                Ensure statutory compliance today.
              </p>

              <button
                onClick={handleBooking}
                className="btn-primary"
                style={{ width: '100%', justifyContent: 'center' }}
              >
                Book Now
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default SafetyLegalCompliance;
